import { Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface LoadingSpinnerProps {
  size?: 'sm' | undefined;
  className?: string;
  text?: string;
}

export default function LoadingSpinner({ size, className, text }: LoadingSpinnerProps) {
  const { t } = useTranslation();
  const defaultText = t('common.loading', { defaultValue: '読み込み中...' });
  
  return (
    <div className={`text-center ${className || ''}`}>
      <Spinner animation="border" role="status" size={size}>
        <span className="visually-hidden">{text || defaultText}</span>
      </Spinner>
      {text && (
        <div className="mt-2">
          <small className="text-muted">{text}</small>
        </div>
      )}
    </div>
  );
}

